import styled, { keyframes } from "styled-components";
const fadein = keyframes`
  from {
    transform-origin: top;
    transform: scale(0.8);
    opacity: 0;
  }
  to {
    transform-origin: top;
    transform: scale(1);
    opacity: 1;
  }
`;

// Light BG: 
// background: #f9f9f9;
const StyledSnapOptions = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-template-rows: repeat(3, minmax(0, 1fr));
  grid-column-gap: 8px;
  grid-row-gap: 8px;
  background: #222;
  border: solid 1px rgba(150, 150, 150, 0.2);
  border-radius: 6px;
  transform-origin: center;
  animation: ${fadein} 0.3s ease-in-out;
  min-width: 150px;
  min-height: 100px;
`;
export default StyledSnapOptions